import Vue from 'vue';
import VuetifyPlugin from './plugins/vuetify';
import App from './App.vue';
import router from './router';
import './registerServiceWorker';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import {GTag} from '@/lib/google-analytics';

Vue.config.productionTip = false;

new Vue({
  vuetify: VuetifyPlugin,
  router,
  render: (h) => h(App),
  provide: {
    $gtag: new GTag('UA-132810931-2')
  }
}).$mount('#app');
